function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { PureComponent } from "react";
import PropTypes from "prop-types";
const eventsChanged = (yeoldevents, yonnewevents) => yeoldevents.sort().toString() !== yonnewevents.sort().toString();
class Idle extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      idle: this.props.defaultIdle
    });
    _defineProperty(this, "timeout", null);
    _defineProperty(this, "handleEvent", () => {
      clearTimeout(this.timeout);
      this.setTimeout();
      if (this.state.idle) {
        this.handleChange(false);
      }
    });
  }
  componentDidMount() {
    this.attachEvents();
    this.setTimeout();
  }
  componentDidUpdate(prevProps) {
    if (eventsChanged(prevProps.events, this.props.events)) {
      this.removeEvents(prevProps.events);
      this.attachEvents();
    }
  }
  componentWillUnmount() {
    this.removeEvents();
    clearTimeout(this.timeout);
  }
  attachEvents() {
    this.props.events.forEach(event => {
      window.addEventListener(event, this.handleEvent, true);
    });
  }
  removeEvents(events = this.props.events) {
    events.forEach(event => {
      window.removeEventListener(event, this.handleEvent, true);
    });
  }
  handleChange(idle) {
    if (idle && this.props.cancelTimerOnIdle) {
      this.removeEvents();
      clearTimeout(this.timeout);
      this.props.onChange({
        idle
      });
    } else {
      if (this.props.cancelTimerOnActivity) {
        this.removeEvents();
        clearTimeout(this.timeout);
        this.props.onChange({
          idle
        });
      } else {
        this.props.onChange({
          idle
        });
        this.setState({
          idle
        });
      }
    }
  }
  setTimeout() {
    this.timeout = setTimeout(() => {
      this.handleChange(true);
    }, this.props.timeout);
  }
  render() {
    return this.props.render(this.state);
  }
}
export default Idle;
Idle.propTypes = {
  onChange: PropTypes.func,
  timeout: PropTypes.number,
  defaultIdle: PropTypes.bool,
  render: PropTypes.func,
  events: PropTypes.arrayOf(PropTypes.string),
  cancelTimerOnIdle: PropTypes.bool,
  cancelTimerOnActivity: PropTypes.bool
};
Idle.defaultProps = {
  defaultIdle: false,
  render: () => null,
  onChange: () => null,
  timeout: 1000,
  events: ["mousemove", "mousedown", "keydown", "touchstart", "scroll"],
  cancelTimerOnIdle: true,
  cancelTimerOnActivity: false
};